import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IFundraiser, IReward } from '../../../../fundraiser/models/fundraiser.model';
import { DonationService, UtilService } from '../../../../shared/services';
import { DonateNowComponent } from '../../../../common/donate-now/components/donate-now/donate-now.component';
import { PaymentUtilService } from '../../../../common/payment/services';

@Component({
  selector: 'app-reward',
  templateUrl: './reward.component.html',
  styleUrls: ['./reward.component.scss']
})
export class RewardComponent implements OnInit {

  @Input() public rewards: IReward[];
  @Input() public fundraiser: IFundraiser;
  @Input() public isFundraiserEnded;
  currency;

  @ViewChild('donateNowBtn', { static: true }) public donateNowBtn: DonateNowComponent;

  constructor(
    public donationService: DonationService,
    public utilService: UtilService,
    public paymentUtilService: PaymentUtilService
  ) { }

  ngOnInit() {
    this.utilService.currency.subscribe({
      next: (res) => {
        this.currency = res;
      }
    });
  }
  checkLength() {
    return this.rewards && this.rewards.length ? true : false;
  }
  /**Donate now */
  donateNow(reward: IReward) {
    if (!this.isFundraiserEnded && reward.status) {
      // const inputs = [
      //   { name: 'fmd_id', value: this.fundraiser.id },
      //   { name: 'reward_id', value: reward.id },
      //   { name: 'fmd_donated_amount', value: reward.amount },
      // ];
      // this.donationService.donateNow(inputs);
      this.paymentUtilService.selectedReward.next(reward);
      this.donateNowBtn.donateNow(this.donateNowBtn.paymentModule);
    }
  }
  /**Remaing backers */
  remainingBackers(item) {
    return item.backers > item.active_backers_count ? item.backers - item.active_backers_count : 0;
  }
  /**Solde out */
  soldOut(item) {
    if (item.backers !== -99) {
      return item.active_backers_count >= item.backers ? true : false;
    } else {
      return true;
    }
  }
}
